const trap = isBeginning => () => isBeginning ? $.tabNext() : $.tabPrev()

const FocusTrap = ({ isBeginning = true }) => (
  <div tabIndex="0" onFocus={ trap(isBeginning) } />
)

export default FocusTrap
